import React from "react";
import { NavLink } from "react-router-dom";
import Image from "../../../partials/Image";
import dummy from "../../../img/image.png";
import { cleanDate } from "../../../util/app";
import TimeAgo from "react-timeago";

const ListView = ({ listNo, patient }) => {
    return (
        <tr className="odd gradeX fade-in">
            <td className="center">
                <strong>{listNo}</strong>
            </td>
            <td className="center patient-img">
                <center>
                    <Image src={patient.profile_picture || dummy} alt={patient.name} height={50} width={50} />
                </center>
            </td>
            <td className="left">
                <NavLink
                    to={{
                        pathname: "/home/patient/profile/" + patient.id,
                    }}
                >
                    <strong>{patient.name}</strong>
                    <br />
                    <small>{patient.email}</small>
                    <br />
                    {patient.admitted ? <span className="label label-sm label-success ">InPatient</span> : <span className="label label-sm label-pink ">OutPatient</span>}
                </NavLink>
            </td>
            <td className="text-center">
                <strong className="text-primary">{patient.hcn}</strong>
                <p>Tel Number: {patient.telNumber}</p>
            </td>
            <td className="text-center">{patient.gender}</td>
            <td className="center">
                <strong>{cleanDate(patient.dob, true)}</strong>
            </td>
            <td className="text-left">
                {cleanDate(patient.created_at, true)}
                <p className="text-primary bold">
                    <TimeAgo date={patient.created_at} />
                </p>
            </td>

            <td className="text-center">
                <NavLink
                    className="mdl-button  mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-primary"
                    to={{
                        pathname: "/home/patient/profile/" + patient.id,
                    }}
                >
                    <span className="material-icons">person</span> View Profile
                </NavLink>
            </td>
        </tr>
    );
};

export default ListView;
